import React, {createContext, Key, ReactNode, useContext, useState} from 'react';

interface LinkedEmittedTableContextType {
    page: number;
    pageSize: number;
    ordering: string | undefined;
    brokerName: Key[];
    collectiveContractCode: Key[];
    contractCode: Key[];
    contractor: Key[];
    credit: Key[];
    debit: Key[];
    documentName: Key[];
    productCode: Key[];
    startDate: Key[];
    taxableAmount: Key[];
    movementCode: Key[];
    setPage: (page: number) => void;
    setPageSize: (pageSize: number) => void;
    setOrdering: (ordering: string) => void;
    setBrokerName: (brokerName: Key[]) => void;
    setCollectiveContractCode: (collectiveContractCode: Key[]) => void;
    setContractCode: (contractCode: Key[]) => void;
    setContractor: (contractor: Key[]) => void;
    setCredit: (credit: Key[]) => void;
    setStartDate: (startDate: Key[]) => void;
    setDebit: (debit: Key[]) => void;
    setDocumentName: (documentName: Key[]) => void;
    setProductCode: (productCode: Key[]) => void;
    setTaxableAmount: (taxableAmount: Key[]) => void;
    setMovementCode: (movementCode: Key[]) => void;
}

const LinkedEmittedTableContext = createContext<LinkedEmittedTableContextType | undefined>(undefined);

export const LinkedEmittedTableProvider: React.FC<{ children: ReactNode }> = ({children}) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [ordering, setOrdering] = useState<string | undefined>(undefined);
    const [brokerName, setBrokerName] = useState<Key[]>([]);
    const [credit, setCredit] = useState<Key[]>([]);
    const [debit, setDebit] = useState<Key[]>([]);
    const [documentName, setDocumentName] = useState<Key[]>([]);
    const [startDate, setStartDate] = useState<Key[]>([]);
    const [productCode, setProductCode] = useState<Key[]>([]);
    const [taxableAmount, setTaxableAmount] = useState<Key[]>([]);
    const [collectiveContractCode, setCollectiveContractCode] = useState<Key[]>([]);
    const [contractCode, setContractCode] = useState<Key[]>([]);
    const [contractor, setContractor] = useState<Key[]>([]);
    const [movementCode, setMovementCode] = useState<Key[]>([]);

    const value: LinkedEmittedTableContextType = {
        page,
        pageSize,
        ordering,
        brokerName,
        collectiveContractCode,
        contractCode,
        contractor,
        credit,
        debit,
        documentName,
        productCode,
        startDate,
        taxableAmount,
        movementCode,
        setBrokerName,
        setCollectiveContractCode,
        setContractCode,
        setContractor,
        setCredit,
        setDebit,
        setDocumentName,
        setPage,
        setPageSize,
        setOrdering,
        setProductCode,
        setStartDate,
        setTaxableAmount,
        setMovementCode
    };

    return (
        <LinkedEmittedTableContext.Provider value={value}>
            {children}
        </LinkedEmittedTableContext.Provider>
    );
};

export const useLinkedEmittedTable = (): LinkedEmittedTableContextType => {
    const context = useContext(LinkedEmittedTableContext);
    if (context === undefined) {
        throw new Error('useLinkedEmittedTable deve essere utilizzato all\'interno di un LinkedEmittedTableProvider');
    }
    return context;
};